export type ComponentTypeName =
    'DatoCmsPage' |
    'DatoCmsLink' |
    'DatoCmsNumberedListItem' |
    'DatoCmsStatisticListItem' |
    'DatoCmsImageListItem' |
    'DatoCmsInformationCardListItem' |
    'DatoCmsLinkListItem' |
    'DatoCmsPageListItem' |
    'DatoCmsListComponent' |
    'DatoCmsHeroComponent' |
    'DatoCmsNewsletterSubscription' |
    'DatoCmsInformationSectionComponent' |
    'DatoCmsTwoColumnInformationCard' |
    'DatoCmsInformationSectionRichText' |
    'DatoCmsTwoColumnRichText' |
    'DatoCmsInformationSectionVideo' |
    'DatoCmsInformationSectionImage' |
    'DatoCmsMadLibsSectionComponent' |
    'DatoCmsBrandLogoSectionComponent' |
    'DatoCmsBrandLogo' |
    'DatoCmsEoFormSectionComponent' |
    'DatoCmsInformationSectionComplexImage' |
    'DatoCmsBlogArticleSection' |
    'DatoCmsBlogPost' |
    'DatoCmsBlogConfiguration' |
    'DatoCmsProductComparisonTable' |
    'DatoCmsProductListItem' |
    'DatoCmsCoverageDetailsGrid' |
    'DatoCmsProductTileListItem' |
    'DatoCmsFaqList' |
    'DatoCmsNavigationBar' |
    'DatoCmsContactInfoListItem' |
    'DatoCmsApiImage' |
    'DatoCmsInformationSectionAccordion' |
    'DatoCmsBlogSectionAccordion' |
    'DatoCmsAdvisorLeadFormSectionComponent';

export class ComponentTypeNames {
    public static readonly PAGE: ComponentTypeName = 'DatoCmsPage';
    public static readonly LINK: ComponentTypeName = 'DatoCmsLink';
    public static readonly NUMBERED_LIST_ITEM: ComponentTypeName = 'DatoCmsNumberedListItem';
    public static readonly STATISTIC_LIST_ITEM: ComponentTypeName = 'DatoCmsStatisticListItem';
    public static readonly IMAGE_LIST_ITEM: ComponentTypeName = 'DatoCmsImageListItem';
    public static readonly INFO_CARD_LIST_ITEM: ComponentTypeName = 'DatoCmsInformationCardListItem';
    public static readonly LINK_LIST_ITEM: ComponentTypeName = 'DatoCmsLinkListItem';
    public static readonly PAGE_LIST_ITEM: ComponentTypeName = 'DatoCmsPageListItem';
    public static readonly LIST_COMPONENT: ComponentTypeName = 'DatoCmsListComponent';
    public static readonly HERO_COMPONENT: ComponentTypeName = 'DatoCmsHeroComponent';
    public static readonly NEWSLETTER_SUBSCRIPTION: ComponentTypeName = 'DatoCmsNewsletterSubscription';
    public static readonly INFORMATION_SECTION: ComponentTypeName = 'DatoCmsInformationSectionComponent';
    public static readonly TWO_COLUMN_INFO_CARD: ComponentTypeName = 'DatoCmsTwoColumnInformationCard';
    public static readonly TWO_COLUMN_RICH_TEXT: ComponentTypeName = 'DatoCmsTwoColumnRichText';
    public static readonly INFO_SECTION_RICH_TEXT: ComponentTypeName = 'DatoCmsInformationSectionRichText';
    public static readonly INFO_SECTION_VIDEO: ComponentTypeName = 'DatoCmsInformationSectionVideo';
    public static readonly INFO_SECTION_IMAGE: ComponentTypeName = 'DatoCmsInformationSectionImage';
    public static readonly INFO_SECTION_COMPLEX_IMAGE: ComponentTypeName = 'DatoCmsInformationSectionComplexImage';
    public static readonly MAD_LIBS_SECTION: ComponentTypeName = 'DatoCmsMadLibsSectionComponent';
    public static readonly BRAND_LOGO_SECTION: ComponentTypeName = 'DatoCmsBrandLogoSectionComponent';
    public static readonly BRAND_LOGO: ComponentTypeName = 'DatoCmsBrandLogo';
    public static readonly EO_FORM: ComponentTypeName = 'DatoCmsEoFormSectionComponent';
    public static readonly BLOG_ARTICLE_SECTION: ComponentTypeName = 'DatoCmsBlogArticleSection';
    public static readonly BLOG_POST: ComponentTypeName = 'DatoCmsBlogPost';
    public static readonly BLOG_CONFIGURATION: ComponentTypeName = 'DatoCmsBlogConfiguration';
    public static readonly PRODUCT_COMPARISON_TABLE: ComponentTypeName = 'DatoCmsProductComparisonTable';
    public static readonly PRODUCT_LIST_ITEM: ComponentTypeName = 'DatoCmsProductListItem';
    public static readonly COVERAGE_DETAILS_GRID: ComponentTypeName = 'DatoCmsCoverageDetailsGrid';
    public static readonly PRODUCT_TILE_LIST_ITEM: ComponentTypeName = 'DatoCmsProductTileListItem';
    public static readonly FAQ_LIST: ComponentTypeName = 'DatoCmsFaqList';
    public static readonly NAVIGATION_BAR: ComponentTypeName = 'DatoCmsNavigationBar';
    public static readonly CONTACT_INFO_LIST_ITEM: ComponentTypeName = 'DatoCmsContactInfoListItem';
    public static readonly API_IMAGE: ComponentTypeName = 'DatoCmsApiImage';
    public static readonly INFO_SECTION_ACCORDION: ComponentTypeName = 'DatoCmsInformationSectionAccordion';
    public static readonly BLOG_SECTION_ACCORDION: ComponentTypeName = 'DatoCmsBlogSectionAccordion';
    public static readonly ADVISOR_LEAD_FORM: ComponentTypeName = 'DatoCmsAdvisorLeadFormSectionComponent';
}
